<app-homepage-header pageName="Payment"></app-homepage-header>

<section class="section-wrapper p__payment-section mb-60px">
  <div class="py-breadcrumb pt-50px">
    <span class="py-breadcrumb-opacity">{{ 'shipping-address.crat' | translate }}</span>
    <span class="py-breadcrumb-slash">/</span>
    <span class="py-breadcrumb-opacity">{{ 'shipping-address.shipping' | translate }}</span>
    <span class="py-breadcrumb-slash">/</span>
    <span>{{ 'shipping-address.payment' | translate }}</span>
  </div>

  <main class="flex-direction-row mt-40px justify-content-between product-payment__main">

    <div class="flex-direction-column width-48 mr-20px product-payment__main-inner">
      <div class="py-ship mb-30px">
        <div class="py-ship-card">
          <div class="flex-direction-column">
            @if (selectedDeliveryMethod === ShippingType.PICKUP) {
              <span class="py-ship-card-title">{{ 'shipping-method.shipping_method' | translate }}</span>
              <span class="py-ship-card-subtitle">{{ getShippingMethodName() | translate }}</span>
            } @else if (deliveryAddress) {
              <span class="py-ship-card-title">{{ 'shipping-method.ship_to' | translate }}</span>
              <span class="py-ship-card-subtitle">{{ truncateText(deliveryAddress, 40)}}</span>
            } @else {
              <span class="py-ship-card-title">{{ 'shipping-method.shipping_method' | translate }}</span>
              <span class="py-ship-card-subtitle">{{ getShippingMethodName() | translate }}</span>
            }
          </div>
          <button class="text-button tall-button" (click)="return()">{{ 'shipping-method.change' | translate }}</button>
        </div>
      </div>

      <div class="flex-direction-column mb-30px">
        <span class="py-title mb-14px">{{ 'payment.payment' | translate }}</span>

        <div class="flex-direction-column gap-10px">

          <!-- ACTIVE PAYMENT METHODS -->
          <app-payment-type (selectType)="selectType(PaymentType.CREDIT_CARD)"
                            [isSelected]="selectedPaymentType === PaymentType.CREDIT_CARD"
                            [paymentType]="PaymentType.CREDIT_CARD"
                            [translation]="true"
          ></app-payment-type>
          @for(creditCard of creditCards; track creditCard) {
            <app-payment-type
              (selectType)="selectType(PaymentType.EXISTING_CREDIT_CARD, creditCard)"
              [cardLastDigits]="creditCard.cardNumber"
              [isSelected]="selectedPaymentType === PaymentType.EXISTING_CREDIT_CARD && !!(selectedCreditCard) && creditCard.cardHolderId == selectedCreditCard.cardHolderId"
              [paymentType]="PaymentType.EXISTING_CREDIT_CARD">
            </app-payment-type>
          }
          <app-payment-type (selectType)="selectType(PaymentType.IDRAM)"
                            [isSelected]="selectedPaymentType === PaymentType.IDRAM"
                            [paymentType]="PaymentType.IDRAM"
                            [translation]="true"
          ></app-payment-type>
          <app-payment-type (selectType)="selectType(PaymentType.TELCELL)"
                            [isSelected]="selectedPaymentType === PaymentType.TELCELL"
                            [paymentType]="PaymentType.TELCELL"
                            [translation]="true"
          ></app-payment-type>
          <app-payment-type (selectType)="selectType(PaymentType.EASY_WALLET)"
                            [isSelected]="selectedPaymentType === PaymentType.EASY_WALLET"
                            [paymentType]="PaymentType.EASY_WALLET"
                            [translation]="true"
          ></app-payment-type>

          <!-- DISABLED PAYMENT METHODS -->
          <app-payment-type (selectType)="selectType(PaymentType.MY_PAY)"
                                                              [isSelected]="selectedPaymentType === PaymentType.MY_PAY"
                                                              [paymentType]="PaymentType.MY_PAY"
                                                              [translation]="true" [disabled]="false"
        ></app-payment-type>
          <app-payment-type (selectType)="selectType(PaymentType.INECO_PAY)"
                            [isSelected]="selectedPaymentType === PaymentType.INECO_PAY"
                            [paymentType]="PaymentType.INECO_PAY"
                            [translation]="true" [disabled]="true"
          ></app-payment-type>

          <app-payment-type (selectType)="selectType(PaymentType.APPLE_PAY)"
                            [isSelected]="selectedPaymentType === PaymentType.APPLE_PAY"
                            [paymentType]="PaymentType.APPLE_PAY"
                            [translation]="true" [disabled]="true"
          ></app-payment-type>
          <app-payment-type (selectType)="selectType(PaymentType.GOOGLE_PAY)"
                            [isSelected]="selectedPaymentType === PaymentType.GOOGLE_PAY"
                            [paymentType]="PaymentType.GOOGLE_PAY"
                            [translation]="true" [disabled]="true"
          ></app-payment-type>

        </div>
      </div>

      <div class="billing-address-buttons d-flex justify-content-between mt-30px">
        <button class="text-button tall-button" (click)="return()">
          @if (selectedDeliveryMethod === ShippingType.PICKUP) {
            {{'shipping-address.return_to_shipping_method' | translate}}
          } @else {
            {{'shipping-address.return_to_shipping_address' | translate}}
          }
        </button>
        <button class="filled-button tall-button" (click)="pay()">{{'payment.pay_now' | translate}}</button>
      </div>
    </div>

    <app-order-summary
      [allCarts]="products" [totalSumAmd]="totalSumAmd" [totalSumUsd]="totalSumUsd"
      [calculatedSumAmd]="calculatedSumAmd" [calculatedSumUsd]="calculatedSumUsd"
      [payment]="true" [deliveryMethod]="selectedDeliveryMethod"
      (applyPromoCode)="handleApplyPromoCode($event)"
      class="width-48 right-orders-part"
    ></app-order-summary>
  </main>
</section>

<app-footer></app-footer>
